<template>
    <div class="home_wrap">
        <template v-if="!isPhone">
            <HomePc/>
        </template>
        <template v-else>
            <HomeMobile/>
        </template>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import HomeMobile from '../components/homeMobile.vue';
import HomePc from '../components/homePc.vue';
export default {
    name: "home",
    data() {
        return {};
    },
    computed: {
        ...mapState(['isPhone']),
    },
    components: {
        HomePc,
        HomeMobile
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">

</style>